import { render, staticRenderFns } from "./AlertItem.vue?vue&type=template&id=fa3d6a58&scoped=true&"
import script from "./AlertItem.vue?vue&type=script&lang=js&"
export * from "./AlertItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3d6a58",
  null
  
)

export default component.exports